'use client';

import React from 'react';
import Link from 'next/link';
import { ChevronLeft, RotateCcw } from 'lucide-react';

export default function WiderrufPage() {
  return (
    <div className="min-h-screen pb-12" style={{ background: 'var(--background)', color: 'var(--foreground)' }}>
      {/* Header */}
      <div
        className="sticky top-0 z-10 flex items-center gap-3 px-4"
        style={{
          background: 'rgba(27,29,35,0.96)',
          borderBottom: '1px solid var(--border)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          paddingTop: 'calc(env(safe-area-inset-top, 44px) + 12px)',
          paddingBottom: '12px',
        }}
      >
        <Link
          href="/profile"
          className="p-2 rounded-full transition-colors active:scale-95"
          style={{ background: 'var(--muted)', color: 'var(--muted-foreground)' }}
          aria-label="Zurück"
        >
          <ChevronLeft size={18} />
        </Link>
        <h1 className="text-base font-semibold" style={{ color: 'var(--card-foreground)' }}>Widerrufsbelehrung</h1>
      </div>

      {/* Content */}
      <div className="max-w-mobile mx-auto px-4 pt-6 space-y-8">

        {/* Intro notice */}
        <div
          className="rounded-app p-4 flex gap-3 items-start"
          style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
        >
          <RotateCcw size={16} className="mt-0.5 shrink-0" style={{ color: 'var(--primary)' }} />
          <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
            Diese Widerrufsbelehrung gilt für Verbraucher im Sinne des § 13 BGB, die über WINEWOOD Adventure kostenpflichtige Leistungen erwerben.
          </p>
        </div>

        {/* Widerrufsrecht */}
        <section>
          <p className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--muted-foreground)' }}>
            Widerrufsrecht
          </p>
          <div
            className="rounded-app p-4 space-y-3"
            style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
          >
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              Verbraucher haben das Recht, binnen <span className="font-semibold" style={{ color: 'var(--card-foreground)' }}>vierzehn (14) Tagen</span> ohne Angabe von Gründen diesen Vertrag zu widerrufen.
            </p>
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsschlusses.
            </p>
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              Um Ihr Widerrufsrecht auszuüben, müssen Sie uns mittels einer eindeutigen Erklärung (z. B. per E-Mail) über Ihren Entschluss informieren, diesen Vertrag zu widerrufen.
            </p>
            <div className="rounded-lg p-3 space-y-1" style={{ background: 'var(--muted)' }}>
              <p className="text-sm font-semibold" style={{ color: 'var(--card-foreground)' }}>Jannik Weinholtz</p>
              <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>WINEWOOD Adventure</p>
              <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>Sagterländer Str. 6</p>
              <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>28259 Bremen, Deutschland</p>
              <a
                href="mailto:hello@winewood-adventure.com"
                className="text-sm block mt-1 transition-colors"
                style={{ color: 'var(--primary)' }}
              >
                hello@winewood-adventure.com
              </a>
            </div>
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung vor Ablauf der Frist absenden.
            </p>
          </div>
        </section>

        {/* Folgen des Widerrufs */}
        <section>
          <p className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--muted-foreground)' }}>
            Folgen des Widerrufs
          </p>
          <div
            className="rounded-app p-4 space-y-3"
            style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
          >
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              Wenn Sie diesen Vertrag widerrufen, werden Ihnen alle Zahlungen, die Sie geleistet haben, unverzüglich und spätestens binnen vierzehn Tagen ab Eingang Ihres Widerrufs erstattet.
            </p>
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              Für die Rückzahlung wird dasselbe Zahlungsmittel verwendet, das Sie bei der ursprünglichen Zahlung eingesetzt haben, sofern nichts anderes vereinbart wurde.
            </p>
          </div>
        </section>

        {/* Vorzeitiger Beginn der Leistung */}
        <section>
          <p className="text-xs font-semibold uppercase tracking-wider mb-3" style={{ color: 'var(--muted-foreground)' }}>
            Vorzeitiger Beginn der Leistung (WINEWOOD+)
          </p>
          <div
            className="rounded-app p-4 space-y-3"
            style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
          >
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              WINEWOOD+ ist eine digitale Dienstleistung, die unmittelbar nach Abschluss des Abonnements freigeschaltet wird.
            </p>
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              Mit Abschluss des Kaufs verlangen Sie ausdrücklich, dass WINEWOOD Adventure bereits vor Ablauf der Widerrufsfrist mit der Ausführung der Leistung beginnt. Sie bestätigen gleichzeitig, dass Ihnen bekannt ist, dass Sie bei vollständiger Vertragserfüllung Ihr Widerrufsrecht verlieren können, soweit dies gesetzlich vorgesehen ist.
            </p>
            <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              Widerrufen Sie den Vertrag, nachdem die Leistung bereits begonnen hat, kann Wertersatz für die bis zum Widerruf erbrachten Leistungen gemäß{' '}
              <span className="font-semibold" style={{ color: 'var(--card-foreground)' }}>§ 357a BGB</span>{' '}
              verlangt werden.
            </p>
          </div>
        </section>

        {/* Hinweis */}
        <section>
          <div
            className="rounded-app p-4"
            style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
          >
            <p className="text-xs leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
              Stand: August 2026 · Diese Widerrufsbelehrung gilt für Verträge, die über die WINEWOOD Adventure Plattform (App und Website) abgeschlossen werden.
            </p>
          </div>
        </section>

      </div>
    </div>
  );
}
